import { DistribuicaoBolsas } from '@shared/components/distribuicao-bolsas/distribuicao-bolsas.model'
import { RadioConfig } from '@widgets/radio-field/radio-field-provider'
import {
  AnoResidenciaDomainModel,
  ArquivoModel,
  BancoDomainModelList,
  ContestacaoPagamentoModel,
  EspecialidadeDomainModel,
  FaltaCompensadaModel,
  PageInfoModel,
  RegistroOcorrenciaModel,
  SituacaoMatriculaEnum,
  TipoNaturezaJuridicaModel,
  TipoResidenciaDomainModel,
} from './backend'

export const CPF_MASK = '000.000.000-00'
export const CNPJ_MASK = '00.000.000/0000-00'

export interface LoginModel {
  username: string
  password: string
}

export interface TermoCompromissoFormModel {
  arquivo: ArquivoModel
  stDeclarado: boolean
}

export interface FiltroTag {
  queryParamsKey: string
  descricao: string | [string]
}

export interface RegiaoModel {
  id: string
  descricao: string
  nome: string
}

export interface CpfModel {
  cpf: string
}

export interface SandboxTreeModel {
  id: number | string
  descricao: string
  parent?: SandboxTreeModel
}
export interface TreeTipoProgramaModel {
  id: number
  descricao: string
  parent?: TreeTipoProgramaModel
}
export interface TreeNaturezaJuridicaModel {
  id: string
  descricao: string
  codigoConcla: string
  parent?: TipoNaturezaJuridicaModel
}

export interface SandboxUsuario {
  nome: string
  textao: string
  multiSelectedOptions: EspecialidadeDomainModel[]
  treeOptions: SandboxTreeModel[]
  enderecos: SandboxEndereco[]
  anexos: AnexoModel[]
  data: string
  distribuicaoBolsas: DistribuicaoBolsas[]
}

export interface PesquisaSatisfacaoModel {
  classificacao: number
  sugestaoText: string
}

export interface SandboxEndereco {
  numero: number
  logradouro: string
}

export interface AnexoModel {
  nome: string
  arquivo: ArquivoModel
}

export interface ContaModel2 {
  email: string
  confirmacaoEmail: string
  telefones: string[]
}

export interface ContaModel {
  email: string
  confirmacaoEmail: string
}

export interface LoginSandboxModel {
  username: string
  password: string
  cpf: string
  tipoSanguineo: TipoSanguineoModel
  conta: ContaModel
  tipoResidencia: TipoResidenciaDomainModel
}

export interface TipoSanguineoModel {
  id: number
  descricao: string
}

export interface UserInfo {
  name: string
  role: string
  hospital?: string
}

export const ResidenciaMultiRadioModelList = [
  { id: 1, descricao: 'Nome do programa' },
  { id: 2, descricao: 'Área de concentração' },
]

export interface AdicionarRegistroInputModel {
  isFalta: RadioConfig
  isDiaUnico: RadioConfig
  dataInicio: string
  dataFim: string
  justificativa: string
  stDeclarado: boolean
  faltasCompensadas: FaltaCompensadaModel
  diasCompensados: number
}

export const RegistroFolhaRadio = [
  { id: 1, descricao: 'Falta' },
  { id: 2, descricao: 'Compensação de falta' },
]

export const OcorrenciaFalta = [
  { id: 1, descricao: 'Dia único' },
  { id: 2, descricao: 'Período' },
]

export interface FolhaModel {
  competencia: string
  nomePrograma: string
  codigoMs: string
  totalResidentes: number
  dataAbertura: string
  dataFechamento: string
}

export interface InputModalModel {
  input: any
}

export interface CadastroAuxilioMoradiaModel {
  termo: boolean
}

export interface DesistenciaAuxilioMoradiaModel {
  dsMotivoDesistencia: String
}

export interface FolhaResidenteListModel {
  matriculaId: number
  nome: string
  anoResidencia: AnoResidenciaDomainModel
  situacaoPagamento: string
  faltas: number
  totalReceber: number
}

export interface FolhaResidentePayloadModel {
  pageInfo: PageInfoModel
  residentes: FolhaResidenteListModel[]
}

export interface Page<T> extends PageInfoModel {
  content: T[]
}

export const SITUACOES_MATRICULA_ATIVA_IDS = [
  SituacaoMatriculaEnum.AGUARDANDO_CADASTRO,
  SituacaoMatriculaEnum.MATRICULADO,
  SituacaoMatriculaEnum.CADASTRO_INCOMPLETO,
  SituacaoMatriculaEnum.FERIAS,
  SituacaoMatriculaEnum.ATESTADO_MEDICO_MAIS_QUINZE_DIAS,
  SituacaoMatriculaEnum.LICENCA_MATERNIDADE,
  SituacaoMatriculaEnum.PRORROGACAO_LICENCA,
  SituacaoMatriculaEnum.TRANCAMENTO,
  SituacaoMatriculaEnum.TRANCAMENTO_MILITAR,
  SituacaoMatriculaEnum.SUSPENSO,
]

export const SITUACOES_MATRICULA_DESATUALIZADA = [
  SituacaoMatriculaEnum.FERIAS,
  SituacaoMatriculaEnum.ATESTADO_MEDICO_MAIS_QUINZE_DIAS,
  SituacaoMatriculaEnum.LICENCA_MATERNIDADE,
  SituacaoMatriculaEnum.PRORROGACAO_LICENCA,
  SituacaoMatriculaEnum.TRANCAMENTO,
  SituacaoMatriculaEnum.TRANCAMENTO_MILITAR,
  SituacaoMatriculaEnum.SUSPENSO,
]

export interface TransferenciaListFilterModel {
  cnpj: string
  cpf: string
  protocolo: number
  situacoesTransferencia: number[]
}

export type ContestacaoPagamentoFormModel = ContestacaoPagamentoModel & {
  registroOcorrencia: RegistroOcorrenciaModel
}

export interface SenhaTermoModel {
  confirmarSenha: string
  senha: string
  termoAceito: boolean
}

export const BancoContaSalarioDomainModelList = BancoDomainModelList.filter((bancoModel) =>
  ['001', '033', '104', '237', '341'].includes(bancoModel.id)
)
